<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  props: ['data', 'options', 'height'],
  extends: HorizontalBar,
  mounted() {
    this.renderChart(this.data, this.options)
  }
}
</script>
<style>
@media print {
  canvas#horizontalbar-chart {
    width: 100% !important;
  }
}
</style>
